import { Link } from 'react-router-dom';

interface LegalPageLayoutProps {
  title: string;
  subtitle: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export default function LegalPageLayout({
  title,
  subtitle,
  lastUpdated,
  children,
}: LegalPageLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-5">
          <Link to="/" className="inline-flex items-center gap-3 text-sm font-medium text-gray-600 hover:text-gray-900">
            <img src="/branding/filie-icon.svg" alt="Filie" className="h-6 w-6" />
            <span>Back to Filie</span>
          </Link>
          <div className="flex items-center gap-5 text-sm text-gray-500">
            <Link to="/privacy" className="hover:text-gray-800">Privacy</Link>
            <Link to="/security" className="hover:text-gray-800">Security</Link>
            <Link to="/terms" className="hover:text-gray-800">Terms</Link>
            <Link to="/disclosures" className="hover:text-gray-800">Disclosures</Link>
          </div>
        </div>
      </header>

      <main className="px-6 py-12">
        <div className="mx-auto max-w-3xl rounded-2xl border border-gray-200 bg-white p-8 shadow-sm sm:p-10">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Filie Legal</p>
          <h1 className="text-4xl font-bold tracking-tight text-gray-900">{title}</h1>
          <p className="mt-4 text-lg leading-8 text-gray-600">{subtitle}</p>
          <p className="mt-6 text-sm text-gray-400">Last updated {lastUpdated}</p>
          <div className="mt-10 space-y-10 text-gray-700">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
